<template>
  <div>
    <SampleSearchForm :listForm="searchList" @handlerSearch="onSearch" />
    <div class="cml-button-group">
      <el-button
        size="mini"
        type="primary"
        :disabled="selectData.length < 1"
        v-hasPermission="'outside-warehouse-manage/outside-approval-batch'"
        @click="batchVerify"
        >批量审批</el-button
      >
      <el-button
        size="mini"
        type="primary"
        :disabled="selectData.length < 1"
        v-hasPermission="'outside-warehouse-manage/outside-approval-transfer'"
        @click="transferBtn(selectData)"
        >批量转办</el-button
      >
    </div>
    <CommonTable
      ref="CommonTable"
      :loading="tableLoading"
      :tableHead="tableHeadTab"
      :tableData="tableDataTab"
      :tableParam="tableParam"
      @page-size-change="pageSizeChange"
      @select-change="selectChange"
    >
      <template #codeSlot="{ row }">
        <span class="detail-text-class" @click="toUpdate(row, 'detail')">{{
          row.code
        }}</span>
      </template>
      <template #operationSlot="{ row }">
        <el-button
          type="text"
          @click="verifyBtn(row)"
          v-hasPermission="'outside-warehouse-manage/outside-approval-batch'"
          >审批</el-button>
        <el-button
          type="text"
          @click="transferBtn([row])"
          v-hasPermission="'outside-warehouse-manage/outside-approval-transfer'"
          >转办</el-button>
      </template>
    </CommonTable>
    <!-- 审批，详情弹框 -->
    <el-dialog center top="5vh" :visible.sync="dialogVisible" width="1300px">
      <OutsideApplySample
        v-if="dialogVisible && status === 'update'"
        ref="outsideApplySample"
        :status="status"
        @on-success="getList"
        @cancel-btn="dialogVisible = false"
      />
      <OutsideSample v-if="dialogVisible && status === 'detail'" :id="id" />
      <div v-if="status === 'detail'" slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>
    <!-- 转办 -->
    <el-dialog
      top="20%"
      :visible.sync="transferDialogVisible"
      width="500px"
      :close-on-click-modal="false"
    >
      <el-form :model="demandStaff" ref="demandStaffRef">
        <el-form-item
          label="转办人"
          prop="leadApproval"
          :rules="[
            { required: true, message: '请选择转办人', trigger: 'change' } 
          ]"
        >
          <el-select
            v-model="demandStaff.leadApproval"
            clearable
            filterable
            size="mini"
            placeholder="请选择"
          >
            <el-option
              v-for="item in leaderData"
              :key="item.loginName"
              :value="item.loginName"
              :label="item.name"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="transferDialogVisible=false">取消</el-button>
        <el-button type="primary" @click="transferSaveBtn">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import CommonTable from '@/components/CommonTable';
import SampleSearchForm from '@/components/SampleSearchForm';
import OutsideApplySample from '@/components/OutsideApplySample';
import OutsideSample from '@/components/OutsideSample';
export default {
  components: {
    CommonTable,
    SampleSearchForm,
    OutsideApplySample,
    OutsideSample
  },
  props: {
    operateBtn: {
      type: Function,
      default: null,
    },
  },
  data() {
    return {
      demandStaff: {
        leadApproval: '',
        type: 'CHANGE'
      },
      transferDialogVisible: false,
      searchList: {
        list: [
          {
            tag: 'el-input',
            label: '寻样单编号',
            prop: 'code',
            defaultValue: undefined,
            placeholder: '请输入完整寻样单编号',
          },
          {
            tag: 'el-input',
            label: '产品名称',
            prop: 'productName',
            defaultValue: undefined,
            placeholder: '请输入关键字',
          },
        ],
      },
      listForm: { type: 1 },
      tableLoading: false,
      tableParam: {
        pageNo: 1,
        pageSize: 20,
      },
      tableHeadTab: [
        { label: '产品名称', prop: 'productName' },
        {
          label: '寻样单编号',
          prop: 'code',
          slotColumn: true,
          slotName: 'codeSlot',
        },
        { label: '申请时间', prop: 'createDate' },
        { label: '数量', prop: 'num' },
        { label: '单位', prop: 'unit' },
        { label: '样品类型', prop: 'productTypeName' },
        { label: '申请人', prop: 'demandStaffName' },
        { label: '需求品牌', prop: 'demandBrandName' },
        { label: '用途', prop: 'purpose' },
        {
          label: '操作',
          prop: 'operation',
          slotColumn: true,
          slotName: 'operationSlot',
          width: 100,
        },
      ],
      tableDataTab: {},
      userInfo: {},
      dialogVisible: false,
      status: '',
      id: '',
      selectData: [],
      transferList: [],
      leaderData: []
    };
  },
  mounted() {
    this.userInfo = this.$store.getters.userSelf.user;
    this.getList();
    this.$refs.CommonTable.changeHeight(10);
    this.$http.leadApprovalConfig.userList({}).then(result => {
      this.leaderData = result.data.filter(item => item.name !== this.$store.getters.userSelf.user.name);
    })
  },
  methods: {
    transferSaveBtn () {
      this.$refs.demandStaffRef.validate((valid) => {
        if (valid) {
          this.$http.outsideSampleManage.oOrderLeadChange({
            ...this.demandStaff,
            ids: this.transferList.map(item => item.id)
          }).then(() => {
            this.$message.success('转办成功');
            this.transferDialogVisible = false;
          }).catch(err => {
            this.$message.error(err.msg);
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 查询
    onSearch(val) {
      this.tableParam.pageNo = 1;
      this.listForm = { ...this.listForm, ...val };
      this.getList();
    },
    // table数据
    getList() {
      const params = {
        ...this.tableParam,
        data: this.listForm,
      };
      this.tableLoading = true;
      this.$http.outsideSampleManage
        .oOrderLeadInfo(params)
        .then(result => {
          this.tableDataTab = result.data;
          this.selectData = [];
          this.$refs.CommonTable.clearCheckboxRow();
        })
        .catch(err => {
          this.$message.error(err.msg);
        })
        .finally(() => {
          this.tableLoading = false;
        });
    },
    // 审批
    verifyBtn(row) {
      this.$set(row, 'checkStatus', '');
      this.$set(row, 'supplierList', []);
      this.operateBtn('detail', [row]);
    },
    // 转办
    transferBtn(rows) {
      this.transferList = rows;
      this.transferDialogVisible = true;
      this.demandStaff = {
        leadApproval: '',
        type: 'CHANGE'
      }
    },
    batchVerify() {
      this.selectData.map(item => {
        this.$set(item, 'checkStatus', '');
        this.$set(item, 'supplierList', []);
      });
      this.operateBtn('detail', this.selectData);
    },
    // 翻页
    pageSizeChange(pageNo, pageSize) {
      this.tableParam.pageNo = pageNo;
      this.tableParam.pageSize = pageSize;
      this.getList();
    },
    // table选择框
    selectChange(arr) {
      this.selectData = arr;
    },
    // 修改
    toUpdate(row, status) {
      this.status = status;
      this.id = row.id;
      this.dialogVisible = true;
      if (status === 'update') {
        this.$nextTick(() => {
          this.$refs.outsideApplySample &&
            this.$refs.outsideApplySample.getDetail(row.id);
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
</style>